import script from "./datasetList.vue?vue&type=script&lang=js"
export * from "./datasetList.vue?vue&type=script&lang=js"

import "./datasetList.vue?vue&type=style&index=0&id=6784c4e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6784c4e4"]])

export default __exports__